var e=(e,t,a=!1)=>({type:"date",key:e,value:t,isDatetime:a});export{e as makeFilterItemDate};
//# sourceMappingURL=makeFilterItemDate.js.map